export default __webpack_public_path__ + "static/media/arrow-right.da40360f.svg";